import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { InjectionDataModel } from '../_models/injection-data-model';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { WellDetailsModel } from '../_models/well-details-model';
import { Formation } from '../_models/formation';
import { InjectionDataRecord } from '../_models/injection-data-record';


@Component({
  selector: 'app-injection-formations-editor',
  templateUrl: './injection-formations-editor.component.html',
  styleUrls: ['./injection-formations-editor.component.css']
})
export class InjectionFormationsEditorComponent implements OnInit, AfterViewInit {

  private _well: WellDetailsModel;
  private _lastInjection: InjectionDataRecord;

  @Input() injectionDataModel: InjectionDataModel;
  @Input() set well(value: WellDetailsModel) {
    this._well = value;

    this.refreshFormationOptions();
  }

  get well(): WellDetailsModel {
    return this._well;
  }

  @Input() set lastInjection(value: InjectionDataRecord) {
    this._lastInjection = value;
    this.refreshFormationOptions();
  }

  get lastInjection(): InjectionDataRecord {
    return this._lastInjection;
  }

  public form: FormGroup;

  public allowedFormations: any;

  public initialFormationIds: Array<number> = new Array<number>();
  public initialFormationNames: Array<number> = new Array<number>();

  constructor(
    private formBuilder: FormBuilder
  ) {

  }

  ngOnInit(): void {

    function formationIdsValidator() {
      return (control: AbstractControl) => {
        var ret = null;

        var value = control.value;

        if (value.length == null || value.length == 0) {
          var ret: any = {};

          ret.noFormations = true;
        }

        return ret;
      };
    }

    if (this.well != null) {
      var q = 0;
    }

    this.form = this.formBuilder.group({
      'FormationIds': [this.initialFormationIds, formationIdsValidator()],
      'FormationNames': [this.initialFormationNames]
    });
  }

  ngAfterViewInit(): void {

  }

  refreshFormationOptions() {
    if (this.well != null) {

      this.allowedFormations = new Array<any>();

      //Make sure that we have the well and formation records
      if (this.well != null && this.well.Formations != null) {
        this.well.Formations.forEach((f: any) => {
          var formationOption = {
            Id: null,
            Name: null,
            Selected: false
          };

          formationOption.Id = f.Id;
          formationOption.Name = f.Name;

          if (this.lastInjection != null && this.lastInjection.FormationIds.indexOf(f.Id) > -1) {
            formationOption.Selected = true;
          }

          this.allowedFormations.push(formationOption);
        });
      }
    }

    this.updateFormationIdForm();
  }

  handleFormationSelectedChanged(formationOption) {
    formationOption.Selected = !formationOption.Selected;

    this.updateFormationIdForm();
  }

  updateFormationIdForm() {
    var newFormationIds = new Array<number>();
    var newFormationNames = new Array<number>();

    if (this.allowedFormations != null) {
      this.allowedFormations.forEach((formation) => {
        if (formation.Selected) {
          newFormationIds.push(formation.Id);
          newFormationNames.push(formation.Name);
        }
      });


      if (this.form != null) {
        this.form.controls.FormationIds.setValue(newFormationIds);
        this.form.controls.FormationNames.setValue(newFormationNames);
      }
    }
  }
}
